import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { useLanguage } from '../i18n/LanguageContext';
export function Science() {
  const {
    t
  } = useLanguage();
  const analysisItems = t.science.items;
  return <section className="pt-10 md:pt-14 pb-20 md:pb-28 bg-riam-jet relative overflow-hidden" data-id="element-233">
      <div className="gold-spotlight-top" aria-hidden="true" data-id="element-234" />
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-235">
        <div className="max-w-5xl mx-auto" data-id="element-236">
          <SectionHeading title={t.science.title} subtitle={t.science.subtitle} data-id="element-237" />

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center font-sans text-lg text-riam-gold-light/80 max-w-3xl mx-auto mb-16" data-id="element-238">
            {t.science.p1_1}
            <span className="font-allura font-normal text-3xl md:text-4xl align-middle mx-1 text-riam-gold" data-id="element-239">
              {t.science.p1_highlight}
            </span>{' '}
            {t.science.p1_2}
          </motion.p>

          <div className="grid gap-4 md:gap-6" data-id="element-240">
            {analysisItems.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="gold-border-hover flex flex-col md:flex-row rounded-sm overflow-hidden bg-riam-dark/30" data-id="element-241">
                <div className="md:w-1/3 bg-riam-gold/5 p-6 flex items-center border-b md:border-b-0 md:border-r border-riam-gold/20" data-id="element-242">
                  <h3 className="gold-shine font-serif text-xl" data-id="element-243">
                    {item.title}
                  </h3>
                </div>
                <div className="md:w-2/3 p-6 flex items-center" data-id="element-244">
                  <p className="font-sans text-riam-gold-light/90 text-lg" data-id="element-245">
                    {item.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="surface-elevated rounded-sm px-6 md:px-10 py-10 md:py-12 mt-16 max-w-3xl mx-auto text-center" data-id="element-246">
            <p className="font-script font-semibold italic text-2xl md:text-3xl text-riam-gold leading-relaxed" data-id="element-247">
              {t.science.conclusion_1}
              <span className="font-allura font-normal text-4xl md:text-5xl align-middle mx-1" data-id="element-248">
                {t.science.conclusion_highlight}
              </span>
              {t.science.conclusion_2}
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}